import { CommonModule, Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginationComponent } from 'src/app/home/common/pagination/pagination.component';
import { timestampFormat } from '../../../app/config/moment';
import { WarehouseService } from 'src/app/home/services/warehouse.service';
import { MasterService } from 'src/app/home/services/master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/home/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { AddUserComponent } from '../add-user/add-user.component';
import { ToastMessageComponent } from 'src/app/common/toast-message/toast-message.component';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import { UpdatePasswordModalComponent } from '../modals/update-password-modal/update-password-modal.component';
import { DeleteUserModalComponent } from '../modals/delete-user-modal/delete-user-modal.component';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginationComponent, ToastMessageComponent],
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss' , '../../app.component.scss']
})
export class UserListComponent {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  @ViewChild(ToastMessageComponent) toastMessage: ToastMessageComponent;


  public timestampFormat = timestampFormat;
  
  public warehouseId = "4";
  public warehouses: any = [];
  public warehouseDetails: any;

  public usersList: any = [];
  public roleList: any = [];
  public isUsers: boolean = false;

  public totalPages: number = 0;
  public currentPage: number = 1;
  
  public totalUsers: number = 0;

  public searchInput: string = "";
  public encodedSearchInput: string = "";


  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;

  public selectedRoles = [];

  public popupUserId: number; 
  
  public createdAtSortValue:string = "";
  public orderBy:string = "asc";

  constructor(public userService: UserService, public masterService: MasterService, public dialog: MatDialog, public location: Location, public route: ActivatedRoute, public router: Router){

  }

  ngOnInit(): void {
    this.getUsers();
    this.getRoles();
  }

  getUsers(page: string = "", search: string = "", roles: Array<string> = [], createdAt: string = ""){
    this.userService.getUsers(page, search, roles, createdAt).subscribe((res)=>{
      if (res.data) {
        if (res.data.data.length !== 0) {
          this.totalUsers = res.data.total;
          this.totalPages = res.data.last_page;
          this.usersList = res.data.data;

          if (this.isSearch || this.isFilter) {
            this.isFilterResult = true;
          }else{
            this.isUsers = true;
          }
        }else{
          this.totalUsers = 0;
          this.totalPages = 0;
          if (this.isSearch || this.isFilter) {
            this.isFilterResult = false;
          }else{
            this.isUsers = false;
          }
        }
      }
    })
  }

  getRoles(){
    let fields = ['id', 'name'];
    this.userService.getRoles(fields).subscribe((res)=>{
      if (res.data) {
        this.roleList = res.data;
      }
    });
  }

  getWarehouses(){
    this.masterService.getIndexGet('/warehouses').subscribe((res) => {
      if (res.data && Array.isArray(res.data)) {
        this.warehouses = res.data;
        // Set default warehouse to first one if available
        if (this.warehouses.length > 0) {
          this.warehouseId = this.warehouses[0].id.toString();
        }
      }
    });
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) {
        this.createdAtSortValue = "";
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getUsers("", this.encodedSearchInput);
    }
  }

  createdAtSort(){
    this.isFilter = true;

    if (this.createdAtSortValue === "asc") {
      this.createdAtSortValue = "desc";
    }else{
      this.createdAtSortValue = this.orderBy;
    }   

    this.onFilterChange();
  }

  openRolesPopup(event){
    document.getElementById("roles-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("roles-popup");
  }

  onRolesFilterChange(event){
    if (event.target.checked) {
      this.selectedRoles.push(event.target.value);
    }else{
      this.selectedRoles = this.selectedRoles.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;

    this.onFilterChange();
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.searchInput = "";
      this.createdAtSortValue = "";
      this.selectedRoles = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getUsers("");
    }
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.getUsers("", this.encodedSearchInput, this.selectedRoles, this.createdAtSortValue);
  }

  getQueryPage($event: number){
    this.currentPage = $event;    
    this.getUsers(`${this.currentPage}`, this.encodedSearchInput, this.selectedRoles, this.createdAtSortValue);
  }

  storesMissingPopover(event){
    let closestTableData = event.target.closest('td');
    let popup = closestTableData.getElementsByClassName("stores-missing-popover");

    popup[0].classList.toggle("active");
    event.stopPropagation()

    document.addEventListener('click', function(event: any) {
      if (
        popup[0].className.includes("active") &&
        !popup[0].contains(event.target)
      ) {
        popup[0].classList.remove("active");
      }
    })
  }

  addUserDialog(): void {
    const dialogRef = this.dialog.open(AddUserComponent, {
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessage.showToast("User has been successfully created", "success", 5000);
        this.getUsers("");
      }
    });
  }

  editUserDialog(userId: number): void {
    const dialogRef = this.dialog.open(EditUserComponent, {
      data: {
        userId
      }
    }); 

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessage.showToast("User has been successfully updated", "success", 5000);
        this.getUsers(`${this.currentPage}`, this.encodedSearchInput, this.selectedRoles, this.createdAtSortValue);
      }
    });
  }

  updatePasswordDialog(userId: number, fullName: string): void {
    const dialogRef = this.dialog.open(UpdatePasswordModalComponent, {
      data: {
        userId,
        fullName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status) {
          this.toastMessage.showToast(result.message, "success", 5000);
        }else{
          this.toastMessage.showToast(result.message, "error", 5000);
        }
      }
    });
  }
  
  deleteUserDialog(userId: number, fullName: string): void {
    const dialogRef = this.dialog.open(DeleteUserModalComponent, {
      data: {
        userId,
        fullName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status) {
          this.toastMessage.showToast(result.message, "success", 5000);
          this.getUsers(`${this.currentPage}`, this.encodedSearchInput, this.selectedRoles, this.createdAtSortValue);
        }else{
          this.toastMessage.showToast(result.message, "error", 5000);
        }
      }
    });
  }

  viewUserDialog(userId: number|string): void {
    const dialogRef = this.dialog.open(UserDetailComponent, {
      data: {
        userId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDotPopup(event: any){
    let openedPopup = document.getElementsByClassName("dots-popup");

    let targetedElement = event.target.closest('td');
    let popupDiv = targetedElement.getElementsByClassName("dots-popup")[0];

    Array.from(openedPopup).forEach((el)=>{
      if (el !== popupDiv) {
        el.classList.remove('active');
      }
    })

    popupDiv.classList.toggle("active");
    event.stopPropagation();

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

  refresh(): void {
    this.getUsers(`${this.currentPage}`, this.encodedSearchInput, this.selectedRoles, this.createdAtSortValue);
  }
}
